export const useNewWindowNavigate = () => {
  const openNewWindow = (path: string = '') => {
    window.open(`${window.location.origin}/${path}`, '_blank');
  };
  return openNewWindow
};
